import React, { useState, useEffect, useContext } from "react";
import { HiSearch, HiX } from "react-icons/hi";
import Breadcrumbs from "./Breadcrumbs";
import { TextField, Paper, List, ListItem, ListItemText, Collapse, InputAdornment, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { TransitionGroup } from "react-transition-group";
import { useNavigate } from "react-router";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import { formatTurkishToEnglishString } from "../../../helpers/TodayDate";

const useStyles = makeStyles((theme: any) => ({
  searchContainer: {
    position: "relative",
    width: "100%",
  },
  /* searchInput: {
    width: "100%",
    
    "& .MuiInputBase-input::placeholder": {
      color: theme.palette.primary.main, // Yer tutucu rengini burada ayarlayın
      opacity: 0.5, // Opaklığı 1 olarak ayarlayarak daha belirgin hale getirin
    },
  }, */
  searchResults: {
    position: "absolute",
    top: "100%",
    left: 0,
    width: "100%",
    zIndex: 10,
    marginTop: theme.spacing(1),
  },
  listItem: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    marginBottom: theme.spacing(1),
    "&:last-child": {
      marginBottom: 0,
    },
  },
}));

const SearchBar = () => {
  const classes = useStyles();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [showResults, setShowResults] = useState(false);
  const navigate = useNavigate();
  const { menuListAll } = useContext(ConstantAPISContext);

  useEffect(() => {
    if (searchQuery) {
      const results = menuListAll.filter((menu) =>
        menu.menuAdi.toLowerCase().includes(searchQuery.toLowerCase()) && menu.sayfaLink!=null
      );
      setSearchResults(results);
      setShowResults(true);
    } else {
      setSearchResults([]);
      setShowResults(false);
    }
  }, [searchQuery, menuListAll]);

  const handleClear = () => {
    setSearchQuery("");
    setShowResults(false);
  };

  const handleResultClick = (result: any) => {
    if (result.sayfaLink == null) {
      navigate(`/anasayfa/${formatTurkishToEnglishString(result.menuAdi.replaceAll(" ","-"))}`, {
        state: { altBasliklar: result.altBasliklar },
      });
    } else if (result.sayfaLink.startsWith("http")) {
      window.location.href = result.sayfaLink;
    } else {
      navigate(result.sayfaLink);
    }
    // Arama kutusunu kapatma ve değeri sıfırlama
    handleClear();
  };

  return (
    <div className="d-flex flex-column justify-content-start  align-items-start  gap-2 mt-3 ">
      
      <div className={classes.searchContainer}>
        <TextField
          
          id="search"
          size="small"
         /*  className={classes.searchInput} */
         className="w-100 "
          type="text"
          placeholder="Aramak istediğiniz kelimeyi yazınız..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={searchQuery ? handleClear : undefined}
                  edge="end"
                >
                  {searchQuery ? <HiX size={24} /> : <HiSearch size={24} />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        {showResults && (
          <Collapse in={showResults}>
            <Paper elevation={3} className={classes.searchResults}>
              <List>
                <TransitionGroup>
                  {searchResults.length === 0 ? (
                    <ListItem>
                      <ListItemText primary="Sonuç bulunamadı" />
                    </ListItem>
                  ) : (
                    searchResults.map((result: any, index: number) => (
                      <Collapse key={index}>
                        <ListItem
                          onClick={() => handleResultClick(result)}
                          className={classes.listItem}
                        >
                          <ListItemText primary={result.menuAdi} />
                        </ListItem>
                      </Collapse>
                    ))
                  )}
                </TransitionGroup>
              </List>
            </Paper>
          </Collapse>
        )}
      </div>
      
    </div>
  );
};

export default SearchBar;
